import React, { useState, useEffect, forwardRef } from "react";
import axios from "../../../AxiosClient";
import MaterialTable from "@material-table/core";
import StepperPage from "./StepperPage";
import cronstrue from "cronstrue";

import { makeStyles } from "@material-ui/core/styles";

import { Trans, useTranslation } from "react-i18next";

const useStyles = makeStyles({
  container: {
    display: "flex",
    flexDirection: "column",
  },
  subContainer: {
    marginTop: 20,
  },
  spiderDepth: {
    marginRight: 20,
  },
  description: {
    width: "50%",
  },
  widthInput: {
    maxWidth: "20%",
  },
  classification: {
    width: "15%",
    marginBottom: 5,
  },
  honourRobots: {
    marginLeft: 20,
  },
});

function AddKSToSchedule(props, ref) {
  const { t } = useTranslation();
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [scheduleIds, setScheduleIds] = useState([]);

  useEffect(() => {
    axios.get("/knowledgesource/batchreindex/", { withCredentials:true }).then((res) => {
      setData(res.data.content);
      setLoading(false);
    });
  }, []);

  useEffect(
    () => {
      props.scheduleIds(scheduleIds);
    },
    [scheduleIds]
  );

  const scheduleSelected = (rows) => {
    setScheduleIds(rows.map((row) => row.scheduleId));
  };

  const [columns] = useState([
    {
      title: "id",
      field: "scheduleId",
      hidden: true,
    },
    {
      title: t("schedule_name"),
      field: "scheduleName",
    },
    {
      title: t("manage_ks_description_table_header"),
      field: "scheduleDescription",
    },
    {
      title: t("global_interval"),
      field: "cronExpression",
      render: (rowData) => {
        return cronstrue.toString(rowData.cronExpression);
      },
    },
    {
      title: t("filter_discussions_sort_date_created"),
      field: "dateCreated",
      type: "datetime",
    },
  ]);

  return (
    <>
      <div
        style={{ overflow: "auto", padding: 10, height: "100%", marginTop: 10 }}
      >
        <MaterialTable
          isLoading={loading}
          columns={columns}
          data={data.map((d) => {
            if (scheduleIds.indexOf(d.id) > -1) {
              return { ...d, tableData: { ...d.tableData, checked: true } };
            }
            return d;
          })}
          onSelectionChange={scheduleSelected}
          options={{
            pageSize: 10,
            pageSizeOptions: [5, 10, 15, 20],
            filtering: true,
            headerStyle: { position: "sticky", top: 0 },
            actionsColumnIndex: -1,
            selection: true,
          }}
          title="Schedules"
        />
      </div>
    </>
  );
}

export default StepperPage(forwardRef(AddKSToSchedule));
